import React from "react";
import { Box, Button, Layer, Text } from "grommet";

// Themed replacement for window.confirm() - used for every delete action in
// Funder Allocation so confirmation looks and behaves consistently.
const ConfirmDialog = ({
    title = "Are you sure?",
    message,
    confirmLabel = "Delete",
    onConfirm,
    onCancel,
}) => (
    <Layer onEsc={onCancel} onClickOutside={onCancel} responsive={false}>
        <Box pad="medium" gap="small" width="medium">
            <Text weight="bold">{title}</Text>
            {message && <Text size="small">{message}</Text>}
            <Box
                direction="row"
                gap="small"
                justify="end"
                margin={{ top: "small" }}
            >
                <Button label="Cancel" onClick={onCancel} />
                <Button
                    label={confirmLabel}
                    primary
                    color="status-critical"
                    onClick={onConfirm}
                />
            </Box>
        </Box>
    </Layer>
);

export { ConfirmDialog };
